var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9593 10.2927C13.5757 9.68081 14.0517 9.07274 14.3627 8.63668C14.5653 8.35248 14.6667 8.21034 14.6667 8.00001C14.6667 7.78968 14.5653 7.64754 14.3627 7.36334C13.4519 6.0863 11.1261 3.33334 8.00001 3.33334C7.39481 3.33334 6.81961 3.43652 6.27886 3.61219M4.49829 4.49829C3.15413 5.40481 2.16144 6.62845 1.63737 7.36334C1.43468 7.64754 1.33334 7.78968 1.33334 8.00001C1.33334 8.21034 1.43468 8.35248 1.63737 8.63668C2.54808 9.91374 4.87386 12.6667 8.00001 12.6667C9.32721 12.6667 10.5101 12.1705 11.5017 11.5017",
    stroke: "#76B72A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57191 6.66666C6.21855 7.01999 6 7.50819 6 8.04739C6 9.12579 6.8742 9.99999 7.9526 9.99999C8.4918 9.99999 8.98 9.78146 9.33333 9.42806",
    stroke: "#76B72A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic-eye.f86d7d390a1847e1ea6a1f9238acbe4f.svg";
export { ForwardRef as ReactComponent };